<script>
import {isBridgeAvailable, nativeTakePhoto} from "@/utils/native-bridge";
import {signEnter} from "@/api/visit-api";
import {uploadBase64File} from "@/utils/fileUploadUtils";
import {areaCheckMixin} from "@/utils/myMixins";
import MyNotifyDialog from "@/components/MyNotifyDialog.vue";
import {myPath} from "@/utils/constant";

export default {
  name: "SignEnteerPage",
  components: {MyNotifyDialog},
  mixins: [areaCheckMixin],
  data() {
    return {
      title: "签到",
      needImage: true,

      camera: {
        ifCameraOpen: false,
        stream: null,
        photoUrl: null,
      },

      // params
      applyInfo: null,
      visitorInfo: null,
      idCardCheckInfo: null, //  photoKey 、 score

      forms: {},
      formItems0: [],
      formItems1: [],
      formItems2: [],
      formItems3: [],
      formItems4: [],
      visitorCardField: null,
      // 必填提示：页面内自绘弹层（Element MessageBox 挂 body，在 2048 画布 transform 下按钮点不动）
      tip: {show: false, title: "提示", msg: "", okText: "知道了"},

    }
  },

  async mounted() {
    let sw = this.JavaBaseInfo.getBaseInfo("Setting.SignEnterPhoto")
    this.needImage = sw === "1" // 默认关，需显式开启
    this.applyInfo = this.$route.params.applyInfo;
    this.visitorInfo = this.$route.params.visitorInfo || {};
    this.idCardCheckInfo = this.$route.params.idCardCheckInfo;

    this.formItems0 = [
      {label: "访客姓名", value: this.visitorInfo.name},
      {label: "开始时间", value: ""},
      {label: "访客公司", value: this.visitorInfo.company},
    ]
    // 身份证配置为不展示时，确认页不显示身份证号。
    // 显隐跟随后台 VISITOR_BOOK 配置，但配置由首页异步拉取——深链/停留过久/首页拉取
    // 失败等场景下 store 可能还是默认值（无 idCardNo → icHidden=false 误显示），
    // 因此构建字段前先确保配置就绪
    if (!this.$store.state.visitorConfigSetting.idCardNo) {
      await this.$store.dispatch("requestVisitorConfigSetting")
    }
    if (!this.$store.getters.icHidden) {
      this.formItems0.push({label: "身份证号", value: this.visitorInfo.ic})
    }
    // 团访单显示团名与联系电话
    if (this.applyInfo && this.applyInfo.groupName) {
      this.formItems0.push({
        label: "团访名称",
        value: this.applyInfo.groupTel ? this.applyInfo.groupName + "（" + this.applyInfo.groupTel + "）" : this.applyInfo.groupName
      })
    }
    // 车牌行前有条件推入的身份证号/团访名称行，索引随配置漂移——
    // 回填必须走对象引用，禁止再按下标写（formItems0[4] 在隐藏证件号的租户上越界炸断 mounted，
    // 被访人字段虽已推入 formItems 但渲染切片 formItems2/3/4 不再生成，整行消失）
    const carField = {label: "车牌号码", value: "", editable: false}
    this.formItems0.push(carField)

    // 访客编码=前台发给访客的实物卡编号，签到现场手填（必填），随签到落 vt_record.enter_card_no。
    // 原来这一格是「备注信息」（只读展示预约单 note），改造后不再回填 note。
    this.visitorCardField = {
      label: "访客编码",
      value: "",
      editable: true,
      placeholder: "请填写访客卡上的编号",
      required: true,
    }

    this.formItems1 = [
      {label: "手机号码", value: this.visitorInfo.tel},
      {label: "结束时间", value: ""},
      {label: "来访事由", value: ""},
      this.visitorCardField,
    ]

    const employee = this.applyInfo.employee || {}
    this.formItems = [
      {label: "被访人姓名", value: employee.name},
      {label: "被访人邮箱", value: employee.email},
    ]

    this.applyInfo.forms.forEach(item => {
      if (item.name === "startTime") {
        let time = `${this.applyInfo.beginDate} ${this.applyInfo.beginTime.substr(0, 5)}`
        this.formItems0[1].value = time
      } else if (item.name === "endTime") {
        let time = `${this.applyInfo.endDate} ${this.applyInfo.endTime.substr(0, 5)}`
        this.formItems1[1].value = time
      } else if (item.name === "reason") {
        this.formItems1[2].value = item.value
      } else if (item.name === "carNumber") {
        carField.value = item.value
      } else {
        this.formItems.push({label: item.title, value: item.value})
      }
    })
    this.formItems2 = this.formItems.filter((item, index) => index % 3 === 0)
    this.formItems3 = this.formItems.filter((item, index) => index % 3 === 1)
    this.formItems4 = this.formItems.filter((item, index) => index % 3 === 2)

    if (this.idCardCheckInfo && this.idCardCheckInfo.photoKey) {
      this.camera.photoUrl = this.toPhotoDataUrl(this.idCardCheckInfo.photoKey)
    }
  },

  methods: {
    showTip(msg) {
      this.tip = {show: true, title: "提示", msg: msg, okText: "知道了"}
    },

    onCancelClick() {
      this.$router.back()
    },

    // 壳内原生 filePathToBase64 返回的已是完整 data:image/jpeg;base64,xxx，
    // 再拼前缀会成双前缀非法 URL（<img> 不显示、上传也损坏），这里统一规范化
    toPhotoDataUrl(raw) {
      if (!raw) return ""
      if (raw.startsWith("data:image")) return raw
      return "data:image/jpeg;base64," + raw
    },

    startCamera() {
      console.log("startCamera")
      // h5pack 壳内 WebView 不放行 getUserMedia，改走原生拍照（前置），拍完直接回填照片
      if (isBridgeAvailable()) {
        nativeTakePhoto('front').then(asset => {
          if (asset && asset.canceled) return // 用户取消，静默返回
          if (asset && asset.base64) {
            this.camera.photoUrl = this.toPhotoDataUrl(asset.base64)
          } else {
            this.$message.error("拍照失败，请重试")
          }
        }).catch(err => {
          console.error("nativeTakePhoto err: " + err);
          this.$message.error("拍照失败，请重试")
        })
        return
      }
      this.camera.ifCameraOpen = true;
      this.$nextTick(() => {
        // facingMode:'user' 为非强制约束，优先前置，设备无前置时自动回退可用摄像头
        navigator.mediaDevices.getUserMedia({video: {facingMode: "user"}})
            .then(stream => {
              console.log("get stream", stream)
              this.videoElement.srcObject = stream;
              this.camera.stream = stream;
            })
            .catch(err => {
              console.error("An error occurred: " + err);
              this.camera.ifCameraOpen = false;
              this.$message.error("无法打开摄像头，请检查浏览器权限")
            })
      });
      // this.stopCamera();

    },

    capturePhoto() {
      console.log("capturePhoto")
      try {
        const video = this.$refs.video;
        if (!video || !video.videoWidth) {
          this.$message.error("相机未就绪，请稍候再拍")
          return
        }
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        this.camera.photoUrl = canvas.toDataURL('image/jpeg', 0.9);
      } catch (err) {
        console.error("An error occurred capturing photo: " + err);
      }
    },

    stopCamera() {
      console.log("stopCamera")
      this.camera.ifCameraOpen = false;
      if (this.camera.stream) {
        this.camera.stream.getTracks().forEach(track => {
          if (track.readyState == 'live') {
            track.stop();
          }
        });
        this.camera.stream = null;
      }
    },


    onCameraClick() {
      if (this.camera.ifCameraOpen) {
        this.capturePhoto();
        this.stopCamera();
      } else {
        this.startCamera();
      }
    },

    async onSubmitClick() {
      // 提交链整体兜底：任何异常都必须给用户反馈，严禁静默失败
      try {
        // 访客编码（前台发的实物卡编号）必填：没填直接弹层拦住，不允许提交签到
        const visitorCardNo = ((this.visitorCardField && this.visitorCardField.value) || "").toString().trim()
        if (!visitorCardNo) {
          this.showTip("请填写访客编码（访客卡上的编号）后再签到。")
          return
        }
        this.visitorCardField.value = visitorCardNo

        if (this.needImage && !this.camera.photoUrl) {
          this.$message.error("请先拍照");
          return
        }


      let applyId = this.applyInfo.id
      let visitorCode = this.visitorInfo.code
      let deviceId = this.$store.state.deviceId
      let areaId = this.$store.state.areaId
      let photoKey = null
      let certPhotoKey = null
      let icCompareResult = this.idCardCheckInfo && this.idCardCheckInfo.score > 80 ? "pass" : ""
      let icCompareScore = this.idCardCheckInfo ? this.idCardCheckInfo.score : 0

      if (this.camera.photoUrl) {
        photoKey = "sign/photo/" + applyId + "-" + visitorCode + ".jpg"
        uploadBase64File(this.camera.photoUrl, photoKey).then((res) => {
          console.log("upload photo success" + res)
        }).catch((err) => {
          console.log("upload photo error", err)
        })
      }

      if (this.visitorInfo.ic) {
        const base64Image = this.JavaBaseInfo.getBase64Image(this.visitorInfo.ic);
        if (base64Image) {
          const objectKey = "sign/photo/" + applyId + "-" + this.visitorInfo.ic + ".jpg"
          uploadBase64File(base64Image, objectKey).then((res) => {
            console.log("upload ic photo success" + res)
          }).catch((err) => {
            console.log("upload ic photo error", err)
          })
          certPhotoKey = objectKey
        }
      }


      if (!await this.checkDeviceArea(this.applyInfo, true)) {
        // 区域验证失败，不进行签到，
        return
      }
      signEnter(applyId, visitorCode, deviceId, areaId, photoKey, certPhotoKey, icCompareResult, icCompareScore, visitorCardNo).then(({data}) => {
        let printSw = this.JavaBaseInfo.getBaseInfo("Setting.printEnterInfo") === "1" // 默认关，需显式开启
        console.log("signEnter result", data)
        if (data.code === 200) {
          if (data.data.completeState === "LEAVE") {
            this.notify = {
              title: "签到结果", show: true, success: false,
              msg: "您已签离，不能再次签到",
            }
          } else if (data.data.exist === "EXIST") {
            if (printSw) {
              this.notify = {
                title: "签到结果", show: true, success: true,
                msg: "你已签到，是否重新打印", reprint: true,
                rePrintData: () => {
                  this.jumpToPrintPage(data.data)
                },
              }
            } else {
              this.notify = {
                title: "签到结果", show: true, success: true,
                msg: "你已签到", reprint: false,
              }
            }
          } else {
            if (printSw) {
              this.jumpToPrintPage(data.data)
            } else {
              this.notify = {
                title: "签到结果", show: true, success: true,
                msg: "签到成功",
              }
            }
          }
        } else {
          this.notify = {title: "签到结果", show: true, success: false, msg: "签到失败",}
        }
      }).catch((err) => {
        this.logE("VisitCodeCome signEnter err", err)
        this.notify = {title: "签到结果", show: true, success: false, msg: "签到失败，网络异常",}
      })
      } catch (err) {
        console.error("SignEnterPage onSubmitClick err =>", err)
        this.notify = {title: "签到结果", show: true, success: false, msg: "签到失败，请重试或联系工作人员",}
      }
    },

    jumpToPrintPage(signResult) {
      let applyInfo = signResult.apply
      let visitor = signResult.visitor
      let employee = applyInfo.employee || {}
      let reasonObj = applyInfo.forms.find(item => item.name === "reason")
      let reason = reasonObj ? reasonObj.value : ""
      let carObj = applyInfo.forms.find(item => item.name === "carNumber")
      let car = carObj ? carObj.value : ""
      let printData = {
        visitorName: visitor.name,
        visitorCode: signResult.pinCode,
        visitorCompany: visitor.company,
        visitorReason: reason,
        employName: employee.name,
        employDepartment: employee.departmentName,
        visitorCar: car,
        visitorTime: applyInfo.beginDate + " " + applyInfo.beginTime,
        visitorGoods: "",
        idCardNo: visitor.ic,
        visitorPhone: visitor.tel,
      }
      this.$router.push({name: myPath.printPage, params: {printData: printData}})
    },

    onNotifyDialogClose() {
      this.notify.show = false
      this.$router.push({name: myPath.home})
    },
  },

  beforeDestroy() {
    this.stopCamera();
  },


  computed: {
    videoElement() {
      return this.$refs.video;
    },

    // 相机开=拍照；已有照片=重拍；都没有=启动相机
    cameraBtnText() {
      if (this.camera.ifCameraOpen) return "拍 照"
      return this.camera.photoUrl ? "重 拍" : "启动相机"
    },

    // 网格逐行填充会打乱语义顺序（车牌夹在公司与手机之间、结束时间跟在手机后），
    // 这里按业务语义重排：被访人（置顶）→ 访客信息 → 时间 → 事由 → 访客编码 → 其余动态字段
    allFormItems() {
      const priority = ["被访人姓名", "被访人邮箱", "访客姓名", "手机号码", "访客公司", "来访事由",
        "开始时间", "结束时间", "车牌号码", "访客编码"]
      const all = [...this.formItems0, ...this.formItems1, ...this.formItems2, ...this.formItems3, ...this.formItems4]
      const head = []
      const rest = []
      all.forEach(item => {
        const idx = priority.indexOf(item.label)
        if (idx >= 0) {
          head.push({idx, item})
        } else {
          rest.push(item)
        }
      })
      head.sort((a, b) => a.idx - b.idx)
      return [...head.map(h => h.item), ...rest]
    },
  },

}
</script>

<template>
  <div>
    <my-notify-dialog :show="notify.show" :success="notify.success" :msg="notify.msg" :title="notify.title"
                      :reprint="notify.reprint" :rePrintData="notify.rePrintData"
                      @dialogClose="onNotifyDialogClose"></my-notify-dialog>

    <!-- 必填校验提示：画在 2048 画布内（fixed 相对 .pad），不再用 body 级 Element MessageBox -->
    <div v-if="tip.show" class="tip-mask">
      <div class="tip-card">
        <div class="tip-title">{{ tip.title }}</div>
        <div class="tip-msg">{{ tip.msg }}</div>
        <button class="ta-btn primary tip-ok" @click="tip.show = false">{{ tip.okText }}</button>
      </div>
    </div>

    <!-- theme-a：居中标题 + 右上圆返回 + 卡片（左拍照/右字段两列） -->
    <div class="common-page-box">
      <div class="back-btn" @click="onCancelClick">
        <svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="#1a1d21" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>
      </div>

      <div class="page-title" style="font-size:64px;margin-top:48px">{{ title }}</div>

      <div class="card sign-card">
        <div class="camera-col">
          <div class="camera-box">
            <video id="video" ref="video" autoplay muted playsinline="true" webkit-playsinline="true"></video>
            <img v-if="!camera.ifCameraOpen && camera.photoUrl" class="photo-preview" :src="camera.photoUrl" alt="">
            <div v-if="!camera.ifCameraOpen && !camera.photoUrl" class="camera-tip">
              签到拍照{{ needImage ? "（必填）" : "（可选）" }}
            </div>
            <button class="ta-btn primary camera-btn" @click="onCameraClick">
              {{ cameraBtnText }}
            </button>
          </div>
        </div>

        <div class="fields-col">
          <div class="fields-grid">
            <div class="field-row" v-for="(item, index) in allFormItems" :key="item.label + '-' + index">
              <span class="field-label">{{ item.label }}</span>
              <input class="ta-input" :value="item.value" :disabled="!item.editable"
                     :placeholder="item.placeholder || ''"
                     @input="item.value = $event.target.value">
            </div>
          </div>
        </div>
      </div>

      <div class="sign-actions">
        <button class="ta-btn ghost" style="width:320px" @click="onCancelClick">取 消</button>
        <button class="ta-btn primary" style="width:320px" @click="onSubmitClick">签 到</button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.sign-card {
  margin: 40px 96px 0;
  flex: 1;
  min-height: 0;
  padding: 56px 72px 32px;
  display: flex;
  gap: 72px;
  overflow: hidden;
}

.camera-col {
  flex: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.camera-box {
  width: 520px;
  height: 390px;
  border-radius: 24px;
  background: #10130f;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .photo-preview {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .camera-tip {
    // video 占满容器会把 flex 流内的文字挤到右侧，改为绝对定位全宽居中
    position: absolute;
    left: 0;
    right: 0;
    top: 45%;
    transform: translateY(-50%);
    text-align: center;
    font-size: 30px;
    color: #9aa39d;
  }

  .camera-btn {
    position: absolute;
    bottom: 28px;
    left: 50%;
    transform: translateX(-50%);
    height: 84px;
    padding: 0 44px;
    font-size: 28px;
    white-space: nowrap; // 真机 WebView 下文字可能被折行（「启动相/机」），锁定单行
  }
}

.fields-col {
  flex: 1;
  min-width: 0;
  overflow: auto;
  padding-right: 8px;
}

.fields-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 36px 64px;

  .field-row {
    gap: 24px;
    min-width: 0;
  }

  .field-label {
    font-size: 32px;
  }

  .ta-input {
    height: 88px;
    font-size: 30px;
    padding: 0 28px;
    min-width: 0;
  }
}

.sign-actions {
  flex: none;
  display: flex;
  justify-content: center;
  gap: 56px;
  padding: 32px 0 8px;
}

// 必填提示弹层：画布内自绘（Element MessageBox 在 2048 画布 transform 下按钮点不动）
.tip-mask {
  position: fixed;
  inset: 0;
  z-index: 300;
  background: rgba(15, 18, 14, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
}

.tip-card {
  width: 880px;
  padding: 56px 64px 48px;
  border-radius: 28px;
  background: #fff;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);
  text-align: center;
}

.tip-title {
  font-size: 44px;
  font-weight: 700;
  color: #1a1d21;
}

.tip-msg {
  margin-top: 28px;
  font-size: 34px;
  line-height: 1.6;
  color: #4b5563;
}

.tip-ok {
  width: 320px;
  height: 96px;
  font-size: 36px;
  margin-top: 44px;
}
</style>
